import axios from "axios";
import store from "../store";

import { sliceActions } from "../store/auth-slice";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const APIClient = axios.create({
  baseURL: BASE_URL,
});

APIClient.interceptors.request.use((request) => {
  const currentState = store.getState();
  const accessToken = currentState.auth.accessToken;
  if (accessToken) {
    request.headers["Authorization"] = `Bearer ${accessToken}`;
  }
  return request;
});

APIClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { status, config } = error.response;
    if (status === 401 && !config.sent) {
      config.sent = true;
      const refreshToken = localStorage.getItem("refresh") || "";

      if (!refreshToken) {
        localStorage.clear();
        window.location.href = "/auth/login";
      }

      try {
        const response = await axios.post(
          BASE_URL + "/auth/refresh-token",
          null,
          {
            headers: {
              "Content-Type": "application/json",
              "Refresh-Token": refreshToken,
            },
          }
        );
        if (!response) {
          throw error;
        }
        if (response.data) {
          const { token: accessToken, refreshToken } = response.data;
          store.dispatch(sliceActions.setAccessToken(accessToken));
          localStorage.setItem("refresh", refreshToken);
          config.headers["Authorization"] = `Bearer ${accessToken}`;
        } else {
          throw error;
        }
      } catch (error) {
        localStorage.clear();
        window.location.href = "/auth/login";
      }
      return await Promise.resolve(APIClient.request(config));
    } else {
      console.log("Something went wrong!");
      throw error;
    }
  }
);

export default APIClient;
